import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcorporatecabbookinginpune() {



  const cardData =
  {
    keyword: 'Wedding Cab Bookings in Pune',
    heading: 'Aaryan Travels: Wedding Cab Bookings in Pune',
    headingDescription: ' Aaryan Travels offers premium Wedding Cab Bookings in Pune to make your special day seamless and elegant with well-coordinated transportation for guests, family members, and VIP entries. Whether you need luxury sedans for the bride and groom, spacious SUVs for family travel, or tempo travellers for group pickup and drop, our fleet ensures comfort, style, and punctuality. We provide decorated wedding cars on request, uniformed chauffeurs, and multiple vehicle arrangements for Baraat, reception, and airport pickups for relatives. From Kothrud to Kharadi, Pimpri-Chinchwad to Baner, Aaryan Travels delivers reliable and well-managed wedding transportation services across Pune with flexible hourly or full-day booking options.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


"services": [
  {
    "name": "Wedding Cab Bookings in Pune",
    "description": "Make your special day flawless with our dedicated Wedding Cab Booking service in Pune. We provide timely, elegant, and comfortable transportation solutions tailored for weddings, including pickup and drop services for the bride, groom, guests, and wedding party. Our professional chauffeurs ensure a smooth and dignified travel experience, handling all routes efficiently so you can focus on your celebration."
  },
  {
    "name": "Pune Wedding Cab Hire",
    "description": "Our Pune Wedding Cab Hire offers a wide range of vehicles specially curated for weddings—from luxurious sedans to spacious SUVs. Whether you need transport for the couple, close family members, or large groups of guests, our fleet is well-maintained and adorned with wedding decor options. We prioritize punctuality, comfort, and style to enhance your wedding experience."
  },
  {
    "name": "Luxury Wedding Cab Pune",
    "description": "Experience premium luxury on your wedding day with our Luxury Wedding Cab service in Pune. Choose from high-end sedans, limousines, and SUVs equipped with plush interiors and advanced amenities. Our chauffeurs are trained to provide a courteous and discreet service, ensuring a memorable and grand entrance or departure for the bride and groom."
  },
  {
    "name": "Chauffeur Cab for Wedding Pune",
    "description": "Our Chauffeur Cab for Wedding service in Pune provides professional, courteous drivers trained to handle wedding day schedules with precision. From early morning ceremonies to late-night receptions, our chauffeurs are available to accommodate any timing, ensuring safe and stress-free transportation for all wedding participants."
  },
  {
    "name": "Wedding Sedan Rental Pune",
    "description": "Opt for our Wedding Sedan Rental service in Pune for elegant and comfortable rides on your special day. Perfect for the bride and groom or close family members, our sedans offer a smooth ride with ample space for wedding attire. These vehicles are regularly serviced and sanitized to meet the highest standards of cleanliness and reliability."
  },
  {
    "name": "Wedding SUV Hire Pune",
    "description": "Hire spacious and stylish SUVs for your wedding party in Pune. Our Wedding SUV Hire caters to larger groups, ensuring everyone travels together comfortably. With modern amenities and expert chauffeurs, these SUVs are ideal for wedding guests, family outings, and group transfers during wedding festivities."
  },
  {
    "name": "Best Cab for Wedding Pune",
    "description": "We provide the Best Cab options for weddings in Pune, combining luxury, reliability, and affordability. Our service includes customized packages that cover multi-day events, multiple pick-ups, and drop-offs, ensuring seamless coordination with your wedding planner for stress-free transportation logistics."
  },
  {
    "name": "Employee Transport for Wedding Pune",
    "description": "Planning weddings at your company or need transport for staff during wedding seasons? Our Employee Transport for Wedding service in Pune offers safe, punctual, and comfortable cabs for your employees attending wedding events, ensuring timely arrivals and smooth commutes."
  },
  {
    "name": "Office Cabs for Wedding Pune",
    "description": "Office Cabs for Wedding in Pune provide corporate clients with dedicated vehicles for transporting employees and guests to and from wedding venues. Our professional service ensures that office groups enjoy comfortable rides without any logistical hassle during wedding celebrations."
  },
  {
    "name": "Wedding Travel Services Pune",
    "description": "Our comprehensive Wedding Travel Services in Pune cover all your transportation needs during wedding functions. From airport pickups to inter-venue transfers and guest shuttling, we offer well-coordinated, reliable travel solutions that keep your wedding schedule running smoothly."
  },
  {
    "name": "Cab Booking for Wedding Events Pune",
    "description": "Book cabs effortlessly for wedding events in Pune with our dedicated Cab Booking platform. Enjoy instant confirmations, customizable packages, and a fleet of vehicles suited for all group sizes and budgets. Our service ensures your wedding transport needs are met promptly and professionally."
  },
  {
    "name": "Wedding Chauffeur Pune",
    "description": "Our Wedding Chauffeur service in Pune provides expert drivers who specialize in wedding day transportation. Discreet, well-groomed, and punctual, these chauffeurs ensure that every ride is safe, smooth, and dignified, adding a touch of elegance to your special day."
  }
],
"tableData": [
  ["Wedding Cab Bookings in Pune", "Pune Wedding Cab Hire"],
  ["Luxury Wedding Cab Pune", "Chauffeur Cab for Wedding Pune"],
  ["Wedding Sedan Rental Pune", "Wedding SUV Hire Pune"],
  ["Best Cab for Wedding Pune", "Employee Transport for Wedding Pune"],
  ["Office Cabs for Wedding Pune", "Wedding Travel Services Pune"],
  ["Cab Booking for Wedding Events Pune", "Wedding Chauffeur Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Wedding Cab Booking Service in Pune",
    "WhyChoosedescription": "Aaryan Travels provides reliable and elegant cab services tailored for weddings and special occasions in Pune."
  },
  {
    "WhyChooseheading": "Timely Pickup to Keep Your Wedding Schedule on Track",
    "WhyChoosedescription": "Our drivers ensure punctual pickups and drop-offs to make your wedding day smooth and stress-free."
  },
  {
    "WhyChooseheading": "Clean and Stylish Vehicles for a Grand Entrance",
    "WhyChoosedescription": "Travel in well-maintained, air-conditioned cars that add elegance and comfort to your special day."
  },
  {
    "WhyChooseheading": "Professional Drivers with Experience in Wedding Events",
    "WhyChoosedescription": "Our courteous and skilled drivers understand the importance of your wedding schedule and routes."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available anytime to assist with your wedding cab bookings and queries."
  },
  {
    "WhyChooseheading": "Flexible Vehicle Options to Match Your Wedding Needs",
    "WhyChoosedescription": "Choose from luxury sedans, SUVs, or tempo travellers for transporting your family and guests."
  },
  {
    "WhyChooseheading": "Customizable Packages for Multiple Days and Routes",
    "WhyChoosedescription": "We offer tailored packages for wedding ceremonies, receptions, and other events."
  }
]























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer wedding cab booking services in Pune?',
    answer: 'Yes, Aaryan Travels provides elegant and reliable wedding cab booking services in Pune to make your special day seamless.',
  },
  {
    question: 'How can I book wedding cabs in Pune with Aaryan Travels?',
    answer: 'You can book wedding cabs through our website, mobile app, or by contacting our dedicated customer support team.',
  },
  {
    question: 'What types of vehicles are available for wedding cab bookings in Pune?',
    answer: 'We offer a range of premium vehicles including sedans, SUVs, and luxury cars perfect for weddings and special occasions.',
  },
  {
    question: 'Can I book multiple cabs for a wedding event in Pune?',
    answer: 'Yes, Aaryan Travels can arrange multiple cabs to accommodate your entire wedding party and guests.',
  },
  {
    question: 'Are the drivers experienced in handling wedding cab services in Pune?',
    answer: 'Absolutely. Our drivers are professional, courteous, and trained to provide a smooth and respectful service for weddings.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for wedding cab bookings in Pune?',
    answer: 'Yes, you can specify customized pickup and drop points based on your wedding itinerary.',
  },
  {
    question: 'Is wedding cab service available on the day and time I need in Pune?',
    answer: 'Yes, Aaryan Travels offers flexible wedding cab services available on your preferred date and time.',
  },
  {
    question: 'What safety and hygiene measures are followed for wedding cabs in Pune?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety protocols to ensure a safe journey.',
  },
  {
    question: 'Do you provide special packages or discounts for wedding cab bookings in Pune?',
    answer: 'Yes, we offer customized packages and discounts for large wedding bookings. Contact us for details.',
  },
  {
    question: 'What payment options are accepted for wedding cab bookings in Pune?',
    answer: 'We accept cash, cards, UPI, and digital wallets for convenient and secure payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sachin Joshi',
    feedback: 'Aaryan Travels made our wedding transportation smooth and hassle-free. The cabs and drivers were excellent.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aishwarya Desai',
    feedback: 'Highly recommend Aaryan Travels for wedding cab bookings in Pune. Professional and punctual service.',
    rating: 5,
  },
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Corporate Cab Bookings in Pune",
  "image": "https://aaryantravels.com/assets/images/wedding-cab-pune.jpg", // replace with actual image URL
  "description": "Elegant and reliable wedding corporate cab bookings in Pune by Aaryan Travels. Offering luxury sedans and SUVs with professional chauffeurs for weddings, corporate events, and guest transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // example rating, update as needed
    "ratingCount": "2500", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/wedding-corporate-cab-bookings-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>Wedding Cab Bookings in Pune | Luxury & Reliable | Aaryan Travels</title>
  <meta
    name="description"
    content="Elegant and reliable wedding corporate cab bookings in Pune by Aaryan Travels. Offering luxury sedans and SUVs with professional chauffeurs for weddings, corporate events, and guest transportation."
  />
  <meta
    name="keywords"
    content="Wedding Corporate Cab Bookings in Pune, Pune Wedding Cab Hire, Corporate Event Cabs Pune, Luxury Wedding Cab Pune, Chauffeur Cab for Wedding Pune, Wedding Sedan Rental Pune, Wedding SUV Hire Pune, Best Cab for Wedding Pune, Pune Corporate Wedding Transport, Employee Transport for Wedding Pune, Office Cabs for Wedding Pune, Wedding Travel Services Pune, Corporate Guest Transport Pune, Cab Booking for Wedding Events Pune, Wedding Chauffeur Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingcorporatecabbookinginpune;